module.exports = __webpack_public_path__ + "assets/retina_Parallelogram3VDetailed.2692c4cff23eda1e8dac847a49d20b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Parallelogram3VDetailed.png
// module id = 699
// module chunks = 0